import db from '@/firebase/init.js'

export const mainStorage = {
  state: {
    user: {
      id: null,
      name: null,
      email: null,
      hasManualAccess: null,
      hasPaidAccess: null,
      accessUntil: null,
      loginType: null,
      userType: null,
      phone: null,
      photoURL: null,
      stripeCustomerID: null,
      cHasElevatedAccess: null,
      cHasVideoAccess: null,
      deferredDaysOfAccess: null
    },
    categoryOptions: [],
    documentCategoryOptions: [],
    userFetched: false,
    videoConfigFetched: false,
    documentConfigFetched: false,
    paymentPlans: [],
    paymentConfigFetched: false
  },
  fetchFirestoreUser(uid) {
    db.collection('users').doc(uid).onSnapshot((doc) => {
      if (doc.exists) {
        this.parseUserDocument(doc)
      }
    })
  },
  parseUserDocument(doc) {
    let user = doc.data()
    this.state.user.id = doc.id
    this.state.user.name = user.name
    this.state.user.email = user.email
    this.state.user.hasManualAccess = user.hasManualAccess
    this.state.user.hasPaidAccess = user.hasPaidAccess
    this.state.user.accessUntil = user.accessUntil
    this.state.user.loginType = user.loginType
    this.state.user.userType = user.userType    
    this.state.user.phone = user.phone    
    this.state.user.photoURL = user.photoURL    
    this.state.user.stripeCustomerID = user.stripeCustomerID
    if (user.deferredDaysOfAccess) {
      this.state.user.deferredDaysOfAccess = user.deferredDaysOfAccess
    } else {
      this.state.user.deferredDaysOfAccess = []
    }
    // console.log(this.state.user.deferredDaysOfAccess)
    // Computed
    this.state.user.cHasElevatedAccess = user.userType === 'admin' || user.userType === 'coach'

    this.state.user.cHasVideoAccess = this.state.user.cHasElevatedAccess || user.hasManualAccess || user.hasPaidAccess
  },
  async fetchVideoConfig() {
    // console.log("Fetching video config!")
    if (!this.state.videoConfigFetched) {
      const result = await db.collection('global').doc('videos_config').get()
      const categoryOptions = await result.data().categoryOptions
      categoryOptions.forEach((item) => {
        this.state.categoryOptions.push(item)
      })
    }
    this.state.videoConfigFetched = true
  },
  async fetchDocumentConfig() {
    if (!this.state.documentConfigFetched) {
      const result = await db.collection('global').doc('documents_config').get()
      const categoryOptions = await result.data().categoryOptions
      categoryOptions.forEach((item) => {
        this.state.documentCategoryOptions.push(item)
      })
    }
    this.state.documentConfigFetched = true
  },
  async fetchPaymentConfig() {
    // console.log("Fetching video config!")
    if (!this.state.paymentConfigFetched) {
      const result = await db.collection('global').doc('payments_config').get()
      const paymentPlans = await result.data().paymentPlans
      paymentPlans.forEach((item) => {
        this.state.paymentPlans.push(item)
      })
    }
    this.state.paymentConfigFetched = true
  }
}